module.exports = __webpack_public_path__ + "site/img/index2zh1.743c3230.png";